const BASEPATH = `${process.env.REACT_APP_BACKEND_HOST ||
  `${window.location.protocol}//${window.location.hostname}/api`}`;
const PUBLIC_BASEPATH = `${BASEPATH.split("/api")[0]}/build/api`;
const PYTHON_BASEPATH = `${process.env.REACT_APP_PYTHON_HOST}`;
const APIS = {
  ACCEPTANCE_STATUS: `${BASEPATH}/shared/documents`,
  ACCESS_CONTROLS: `${BASEPATH}/access_controls`,
  ACCOUNTS: `${BASEPATH}/accounts`,
  ACCOUNTS_V2: `${BASEPATH}/v2/accounts`,
  ACTIVITIES: `${BASEPATH}/object-activities/objects`,
  APPROVALS: `${BASEPATH}/approvals`,
  APP_VIEW_CONFIG: `${BASEPATH}/app`,
  ASSETS: `${BASEPATH}/assets`,
  ASSET_BATCH_SHARING: `${BASEPATH}/asset-sharing-batch`,
  ASSET_FOLDER: `${BASEPATH}/folders`,
  ASSET_MY_DOCUMENTS: `${BASEPATH}/my-documents`,
  ASSET_FOLDER_SEARCH: `${BASEPATH}/folders/search`,
  ASSET_SEARCH_SUGGESTION: `${BASEPATH}/folders/suggest`,
  ASSET_SHARING: `${BASEPATH}/asset-sharing`,
  ASSET_STATUS_LIST: `${BASEPATH}/doc-statuses`,
  ASSET_TAGS_LIST: `${BASEPATH}/doc-tags`,
  AUTH: `${BASEPATH}/auth`,
  AUTH_V2: `${BASEPATH}/v2/auth`,
  BATCH_UPDATE_TEMPLATE: `${BASEPATH}/docstemplate`,
  BILLING_INFO: `${BASEPATH}/billing/org/billingInfo`,
  BILLING_INVOICE: `${BASEPATH}/billing/invoices`,
  BUNDELS: `${BASEPATH}/bundles`,
  CANCLE_ESIGNATURE: `${BASEPATH}/esign/documents`,
  CATALOGS: `${BASEPATH}/catalogs`,
  CATEGORIES: `${BASEPATH}/categories`,
  CHARGEBEE_CHECKOUT_URL: `${BASEPATH}/billing/org/checkoutlink`,
  CHARGEBEE_PAYMENT_URL: `${BASEPATH}/billing/org/payment`,
  CHILD_VIEWS: `${BASEPATH}/cviews`,
  CLAUSES: `${BASEPATH}/clauses/`,
  CLAUSE_OPTIONS: `${BASEPATH}/doc-fields/`,
  CLONE_GLOBAL_TEMPLATE: `${BASEPATH}/global_template/clone`,
  COMPONENTS: `${BASEPATH}/doc-components`,
  COMPONENTS_RESTORE: `${BASEPATH}/doc-components-restore`, // Used in case of delete undo
  CREATE_NEW_DOCUMENT: `${BASEPATH}/docs`,
  CREATE_NEW_DOCUMENT_FROM_GLOBAL_TEMPLATE: `${BASEPATH}/docs/global_template`,
  CREATE_ORG: `${BASEPATH}/orgs`,
  CREATE_ORG_v2: `${BASEPATH}/v2/orgs`,
  CRM: `${BASEPATH}/crm_configs`,
  CRM_CALLBACK: `${BASEPATH}/crm/authenticate`,
  CRM_SYNC: `${BASEPATH}/crm/sync`,
  DASHBOARD: `${BASEPATH}/dashboard`,
  DEALS: `${BASEPATH}/deals`,
  DEALTABLES: `${BASEPATH}/deal-tables`,
  DELETE_DOCUMENT_TEMPLATE: `${BASEPATH}/docstemplate`,
  DISSCONNECT_DOCU_SIGN: `${BASEPATH}/docusign/disconnect`,
  DOCS: `${BASEPATH}/docs`,
  DOCS_ACCEPTORS: `${BASEPATH}/v2/doc-acceptors`,
  DOCS_CONTENT: `${BASEPATH}/docs_content`,
  DOCS_RECIPIENTS: `${BASEPATH}/doc-recipients`,
  DOCS_RECIPIENTS_V2: `${BASEPATH}/v2/doc-recipients`,
  DOCUMENTS: `${BASEPATH}/documents`,
  DOCUMENTS_V2: `${BASEPATH}/v2/documents`,
  DOCUMENT_CLAUSE: `${BASEPATH}/clauses/`,
  DOCUMENT_TEMPLATES: `${BASEPATH}/docstemplate/`,
  DOC_ATTACHMENTS: `${BASEPATH}/attachments`,
  DOC_DEALS: `${BASEPATH}/doc-deals`,
  DOC_ENTITIES: `${BASEPATH}/docs/entities`,
  DOC_FIELDS: `${BASEPATH}/doc-fields/`,
  DOC_FIELDS_TYPES: `${BASEPATH}/doc-field-types`,
  DOC_PREVIEW: `${BASEPATH}/docs/preview`,
  DOC_SIGN: `https://account-d.docusign.com/oauth/auth?response_type=code`,
  DOC_SIGNATORY: `${BASEPATH}/doc-signatories`,
  DOC_STAGE: `${BASEPATH}/docs/stage`,
  DOC_STATUS: `${BASEPATH}/docs/status`,
  DOC_TAG: `${BASEPATH}/docs/tag`,
  DOC_TYPES: `${BASEPATH}/doctypes`,
  DOC_AS_TEMPLATE: `${BASEPATH}/documents`,
  ECOMM_PERMALINK: `${BASEPATH}/docstemplate1/ecomm/publish`,
  EDIT_DOCUMENT: `${BASEPATH}/docs/revision/edit`,
  ESIGNATURE: `${BASEPATH}/esign/signature`,
  EXPORT_DOCX: `${BASEPATH}/docs/export`,
  EXPORT_DOCX_V2: `${BASEPATH}/v2/docs/export`,
  FETCH_DOC_SIGN_PDF: `${BASEPATH}/docs`,
  GET_DOCTYPE_ID: `${BASEPATH}/docs/id`,
  GET_DOC_ID: `${BASEPATH}/docs`,
  GET_NOTIFICATIONS: `${BASEPATH}/notifications`,
  GET_QUOTE_ID: `${BASEPATH}/quoteid`,
  GET_REDIRECT_URL: `${BASEPATH}/docusign/connect`,
  GLOBAL_TEMPLATES: `${BASEPATH}/global_template`,
  GLOBAL_TEMPLATES_DEMO: `${BASEPATH}/demo/global_templates`,
  GOOGLE_SHEET_AUTH: `${BASEPATH}/google_auth/`,
  GOOGLE_SHEET_DATA: `${BASEPATH}/google/`,
  GROUPS: `${BASEPATH}/groups`,
  IMAGE_UPLOAD: `${BASEPATH}/images`,
  LEGALLY_BINDED_SIGNATORY: `${BASEPATH}/esign/count`,
  NOTES: `${BASEPATH}/comments`,
  OAUTH_CONSENT: `${PUBLIC_BASEPATH}/auth/clients/authorize`,
  OPPORTUNITIES: `${BASEPATH}/opportunities`,
  OPPORTUNITIES_V2: `${BASEPATH}/v2/opportunities`,
  OPPORTUNITIES_V3: `${BASEPATH}/v3/opportunities`,
  OPPORTUNITY_STAGES: `${BASEPATH}/oppstages`,
  ORGS: `${BASEPATH}/organizations`,
  ORGS_METERS: `${BASEPATH}/orgs/meters`,
  PDF: `${PYTHON_BASEPATH}/quotepdf`,
  PERMA_DOC: `${BASEPATH}/perma/DOC`,
  PERMA_LINK: `${BASEPATH}/perma-link`,
  SNAP_LINK: `${BASEPATH}/snap-link`,
  PING: `${BASEPATH}/ping`,
  PRICE_LISTS: `${BASEPATH}/pricelists`,
  PRODUCTS: `${BASEPATH}/products`,
  PRODUCT_FAMILIES: `${BASEPATH}/product_families`,
  QUOTES: `${BASEPATH}/quotes`,
  QUOTETERM_TEMPLATES: `${BASEPATH}/quotetemplate`,
  QUOTE_DOCUMENT: `${BASEPATH}/quotes`,
  RBAC: `${BASEPATH}/rbac`,
  REFERRAL: `${BASEPATH}/organizations/referral`,
  REVV_OAUTH: `${BASEPATH}/applications/`,
  REVV_OAUTH_CLIENT: `${BASEPATH}/clients/`,
  SAML: `${BASEPATH}/saml2/acs`,
  SAML_SETTINGS: `${BASEPATH}/saml2/settings`,
  SAML_USER_TOKEN: `${BASEPATH}/saml2/token`,
  SEND_DOC_TO_DOCU_SIGN: `${BASEPATH}/docusign/upload-pdf`,
  SF_LOGIN_OAUTH2: `https://login.salesforce.com/services/oauth2/authorize`,
  SF_SAML_AUTH_REQUEST: `${BASEPATH}/saml2/authrequest`,
  SF_TEST_OAUTH2: `https://test.salesforce.com/services/oauth2/authorize`,
  SHARED_DOCUMENTS: `${BASEPATH}/shared/documents`,
  SHARED_DOCUMENTS_V2: `${BASEPATH}/v2/shared/documents`,
  SHARE_DOCUMENT: `${BASEPATH}/sharing/docs`,
  SHARE_DOCUMENT_ATTACHMENT: `${BASEPATH}/shared/attachments`,
  SUPPORT_EMAIL: `${BASEPATH}/support/email`,
  SYNC_DOC_SIGN: `${BASEPATH}/docusign/credentials`,
  TABLES: `${BASEPATH}/tables`,
  TEMPLATES: `${BASEPATH}/v1/templates`,
  TEMPLATES_PUBLISH: `${BASEPATH}/templates/publish`,
  TEMPLATE_COMPONENTS: `${BASEPATH}/template-components`,
  TEMPLATE_COMPONENT_RESTORE: `${BASEPATH}/template-components-restore`,
  TEMPLATE_SEARCH_CONTENT: `${BASEPATH}/template/search`,
  TEMPLATE_SEARCH_SUGGESTIONS: `${BASEPATH}/template/suggestions`,
  TEMPLATE_TAG: `${BASEPATH}/docstemplatetag`,
  TEMPLATE_V2: `${BASEPATH}/v2/templates`,
  TOGGLE_DOCUMENT_TEMPLATE: `${BASEPATH}/template-toggle`,
  UNSPLASH_BASEURL: `https://api.unsplash.com/search/photos`,
  UNUSED_PRODUCTS: `${BASEPATH}/unused_products`,
  UPDATE_DOC_COMPONENT_BATCH: `${BASEPATH}/doc-components-batch`,
  UPDATE_DOC_FIELD: `${BASEPATH}/doc`,
  UPDATE_DOC_FIELD_NON_LOGGED_IN: `${BASEPATH}/shared/documents`,
  UPLOAD_DOCUMENT: `${BASEPATH}/docs/upload`,
  UPLOAD_PDF: `${BASEPATH}/pdf/upload`,
  UPLOAD_QUOTE_DOCUMENT: `${BASEPATH}/docs/convert`,
  UPLOAD_REVISED_DOCUMENT: `${BASEPATH}/docs/revision`,
  UPLOAD_SAML_CERTIFICATE: `${BASEPATH}/saml2/certificate`,
  USERPROFILE: `${BASEPATH}/userprofile`,
  USERS: `${BASEPATH}/users`,
  USERS_V2: `${BASEPATH}/v2/users`,
  USER_FEATURES: `${BASEPATH}/user-features`,
  USER_GROUPS: `${BASEPATH}/usergroups`,
  UPDATE_DOC_SIGNATORY: `${BASEPATH}/doc-signatories`,
  VIEWS: `${BASEPATH}/views`,
  VIEW_METADATA: `${BASEPATH}/meta`,
  WORK_FLOW: `${BASEPATH}/wf`,
  WORK_FLOW_CONDITIONS: `${BASEPATH}/conditions-meta`,
  WORK_FLOW_EVENT: `${BASEPATH}/wf-event`,
  WORK_FLOW_RULES: `${BASEPATH}/wfrules`,
  WORK_FLOW_TRIGGER: `${BASEPATH}/wf-trigger`,
  ZAPIER_KEY: `${BASEPATH}/api-key`,
  ZAPIER_KEY_BASED_ON_ORG: `${BASEPATH}/zapier/api-key`,
  ZH_OAUTH2: `https://accounts.zoho.com/oauth/v2/auth?scope=ZohoCRM.users.ALL,ZohoCRM.modules.ALL,ZohoCRM.settings.ALL`,
  STRIPE_AUTH: `${BASEPATH}/stripe`,
  DOC_REVVAI_METADATA: `${BASEPATH}/revvai/docs`,
  DOC_REVVAI_METADATA_BULK: `${BASEPATH}/revvai/metadata/bulk-download`,
  SHARED_REVVAI_METADATA: `${BASEPATH}/revvai/shared`,
  TEMP_REVVAI_SUGGEST_FIELDS: `${BASEPATH}/revvai/templates/fields/suggest`,
  CLAUSE_ANALYSIS_META: `${BASEPATH}/revvai/clause-analysis/meta`,
  STRIPE_BILLING_CHECKOUT: `${BASEPATH}/stripe/billing/checkout`,
  STRIPE_BILLING_PORTAL: `${BASEPATH}/stripe/billing/portal`,
  STRIPE_BILLING_PAYMENT: `${BASEPATH}/stripe/billing/lastpayment`,
};

// eslint-disable-next-line import/prefer-default-export
export { APIS };



// WEBPACK FOOTER //
// ./src/constants/apiEndpoints.js